import React from 'react'
import RewardsSettingsFlagsCard from './RewardsSettingsFlagsCard'
import RewardsSettingsAccessCard from './RewardsSettingsAccessCard'
import RewardsSettingsExchangesCard from './RewardsSettingsExchangesCard'
import RewardsSettingsAffiliateUuidsCard from './RewardsSettingsAffiliateUuidsCard'
import RewardsSettingsBingxInvitedUsersCard from './RewardsSettingsBingxInvitedUsersCard'
import RewardsSettingsLinksCard from './RewardsSettingsLinksCard'
import RewardsSettingsTrialCard from './RewardsSettingsTrialCard'
import RewardsSettingsManualCommissionsCard from './RewardsSettingsManualCommissionsCard'

export default function RewardsSettingsSection() {
  return (
    <div className="space-y-6">
      <RewardsSettingsFlagsCard />
      <RewardsSettingsAccessCard />
      <RewardsSettingsExchangesCard />
      <RewardsSettingsBingxInvitedUsersCard />
      <RewardsSettingsAffiliateUuidsCard />
      <RewardsSettingsLinksCard />
      <RewardsSettingsTrialCard />
      <RewardsSettingsManualCommissionsCard />
    </div>
  )
}
